import React from "react";
import PropTypes from "prop-types";
import { useClasses } from "@xo-union/react-css-modules";
import classesPropType from "@xo-union/classes-prop-type";
import styles from "../css/index.css";
var ClassesContext = /*#__PURE__*/React.createContext(styles);
export var ThemeProvider = function ThemeProvider(_ref) {
  var children = _ref.children,
    classesProp = _ref.classes;
  var classes = useClasses(styles, classesProp);
  return /*#__PURE__*/React.createElement(ClassesContext.Provider, {
    value: classes
  }, children);
};
process.env.NODE_ENV !== "production" ? ThemeProvider.propTypes = {
  children: PropTypes.node,
  /**
   * Class dependencies
   */
  classes: classesPropType()
} : void 0;
export var useButtonClasses = function useButtonClasses(override) {
  var contextClasses = React.useContext(ClassesContext);
  var ownClasses = useClasses(styles, override);
  if (override !== undefined) {
    return ownClasses;
  }
  return contextClasses;
};